import type {
  SocialSalesSourceCreateInput,
  SocialSalesSourceUpdateInput,
} from "@/modules/social-sales-sources/domain/contracts";
import { Button, Checkbox, Input, Label } from "@devhop/ui";
import { useState } from "react";

export type SocialSalesSourceFormValues = {
  code: string;
  name: string;
  sortOrder: number;
  isActive: boolean;
};

type SocialSalesSourceFormProps = {
  mode: "create" | "edit";
  initialValues?: Partial<SocialSalesSourceFormValues>;
  submitting?: boolean;
  onSubmit: (
    values: SocialSalesSourceCreateInput | SocialSalesSourceUpdateInput,
  ) => void | Promise<void>;
  onCancel: () => void;
};

const defaults: SocialSalesSourceFormValues = {
  code: "",
  name: "",
  sortOrder: 0,
  isActive: true,
};

export function SocialSalesSourceForm({
  mode,
  initialValues,
  submitting,
  onSubmit,
  onCancel,
}: SocialSalesSourceFormProps) {
  const v = { ...defaults, ...initialValues };
  const [isActive, setIsActive] = useState(v.isActive);

  const handle = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const fd = new FormData(e.currentTarget);
    const code = String(fd.get("code") ?? "").trim().toLowerCase();
    const name = String(fd.get("name") ?? "").trim();
    const sortOrderRaw = Number(fd.get("sortOrder"));
    const sortOrder = Number.isFinite(sortOrderRaw) ? sortOrderRaw : 0;

    if (mode === "create") {
      void onSubmit({
        code,
        name,
        sortOrder,
        isActive,
      });
      return;
    }

    void onSubmit({
      code,
      name,
      sortOrder,
      isActive,
    });
  };

  return (
    <form className="space-y-4" onSubmit={handle}>
      <div className="space-y-2">
        <Label htmlFor="sss-code">ລະຫັດ (slug ຕົວເລັກ a-z, ຂີດ)</Label>
        <Input
          id="sss-code"
          name="code"
          required
          defaultValue={v.code}
          placeholder="facebook"
          autoComplete="off"
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="sss-name">ຊື່ສະແດງ</Label>
        <Input
          id="sss-name"
          name="name"
          required
          defaultValue={v.name}
          placeholder="Facebook"
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="sss-sort">ລຳດັບ</Label>
        <Input
          id="sss-sort"
          name="sortOrder"
          type="number"
          required
          defaultValue={v.sortOrder}
        />
      </div>
      <div className="flex items-center gap-2">
        <Checkbox
          id="sss-active"
          checked={isActive}
          onCheckedChange={(c) => setIsActive(c === true)}
        />
        <Label htmlFor="sss-active" className="cursor-pointer font-normal">
          ເປີດໃຊ້ງານ (ສະແດງໃນ POS)
        </Label>
      </div>
      <div className="flex flex-wrap gap-2 pt-2">
        <Button type="submit" disabled={submitting}>
          {submitting ? "ກຳລັງບັນທຶກ..." : "ບັນທຶກ"}
        </Button>
        <Button type="button" variant="outline" onClick={onCancel}>
          ຍົກເລີກ
        </Button>
      </div>
    </form>
  );
}
